import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/rally/crucedeaguastermales2aetapa.jpeg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Inscripción</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>

              <h3><a href={"https://cronometrajeinstantaneo.com/inscripciones/rally-del-viento-a-los-andes-2025/dupla"} target="_blank">
                <i className="fa fa-bicycle"></i> <i className="fa fa-bicycle"></i> Formulario de inscripción duplas</a></h3>
              <h3><a href={"https://cronometrajeinstantaneo.com/inscripciones/rally-del-viento-a-los-andes-2025"} target="_blank">
                <i className="fa fa-bicycle"></i> Formulario de inscripción individual</a></h3>

              <h3>Equipamiento necesario...</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                        <li key={`${d}-${i}`}>{d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                        <li key={`${d}-${i}`}> {d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
